"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Marcus T.",
  quote: "Send It Fit makes training feel like hanging out with a mate who happens to be an expert. No ego, just results.",
  type: "Personal Training"
}, {
  id: 2,
  author: "Sarah L.",
  quote: "Alvin does an excellent job of meeting me where I am, and making sure there's no pressure. I've never felt more confident in my own skin.",
  type: "Lifestyle Coaching"
}, {
  id: 3,
  author: "David K.",
  quote: "Finally, a fitness brand that doesn't take itself too seriously. They take my goals seriously, though!",
  type: "Mobile Fitness"
}];
export default function VoicesOfSatisfaction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}